<template>
    <div class="modal fade" id="editTeamName" tabindex="-1" aria-labelledby="editTeamNameTitle" style="display: none;" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content">
                <div class="modal-header bg-transparent">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body pb-5 px-sm-5 mx-50">
                    <h4>Edit Team Name</h4>
                    <form class="row gy-1 mt-1">
                        <div class="col-12" >
                            <input type="text" class="form-control" name="teamName" id="teamName" v-model="teamName">
                        </div>
                        <div class="col-12 d-flex justify-content-end">
                            <button
                                type="reset"
                                class="btn btn-outline-secondary mt-1 me-1 waves-effect mr-1"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                Cancel
                            </button>
                            <button type="button" class="btn btn-primary mt-1 waves-effect waves-float waves-light" v-on:click="editTeam">
                                <span class="me-50">Save</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { useTeamStore } from '../../../stores/TeamStore.js'
import { hideModal } from '../../../utilities/_helpers'
import { ref } from 'vue';
export default{
    setup(){
        return {
            teamStore: useTeamStore(),
            teamName: ref(),
            hideModal: hideModal
        }
    },
    methods:{
        editTeam(){
            let $this = this;
            if(this.teamName != ""){
                const route = $this.$router.resolve(
                    {
                        name: 'edit-teams',
                        params: {
                            team: $this.teamStore.team.team.id
                        }
                    }
                );
                axios.post(
                    route.href,
                    {
                        name: this.teamName
                    }
                )
                .then(function(response) {
                    if(response.data.error == true) {
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    hideModal('#editTeamName');
                    $this.teamName = "";
                    $this.teamStore.fetchTeam();
                    toastr.success(response.data.message, 'Success!');
                    return;
                }).catch(function(error) {
                    toastr.error(error.response.data.response_msg, 'Error!');
                });
            }
        },
    }
}
</script>